import { useCallback, useEffect, useRef, useState } from 'react';
import { useControllableValue } from 'ahooks';
export const useResize = props => {
  const {
    maxWidth = 0,
    minWidth = 0
  } = props || {};
  const [drawerWidth, setDrawerWidth] = useControllableValue(props, {
    defaultValue: 378,
    defaultValuePropName: 'defaultWidth',
    valuePropName: 'width',
    trigger: 'onWidthChange'
  });
  const [isDragging, setIsDragging] = useState(false);
  const dragStartX = useRef(0);
  const dragStartWidth = useRef(0);
  const handleMouseDown = useCallback(e => {
    e.preventDefault();
    setIsDragging(true);
    dragStartX.current = e.clientX;
    dragStartWidth.current = drawerWidth;
  }, [drawerWidth]);
  const handleMouseMove = useCallback(e => {
    if (!isDragging) return;
    const deltaX = e.clientX - dragStartX.current;
    const newWidth = Math.max(minWidth, Math.min(maxWidth, dragStartWidth.current - deltaX));
    setDrawerWidth(newWidth);
  }, [isDragging]);
  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  // 添加全局鼠标事件监听
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'ew-resize';
      document.body.style.userSelect = 'none';
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);
  return {
    isDragging,
    resizeWidth: drawerWidth,
    handleMouseDown
  };
};